import { styled } from '@project44/manifest-ds';

import { Position } from './utils';

const Element = styled('div', {
  width: 0,
  height: 0,
  position: 'absolute',
});

const ArrowTop = styled(Element, {
  top: '-10px',
  left: 'calc(50% - 10px)',
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderBottom: '10px solid #fff',
});

const ArrowLeft = styled(Element, {
  left: '-10px',
  top: 'calc(50% - 10px)',
  borderTop: '10px solid transparent',
  borderBottom: '10px solid transparent',
  borderRight: '10px solid #fff',
});

const ArrowRight = styled(Element, {
  right: '-10px',
  top: 'calc(50% - 10px)',
  borderTop: '10px solid transparent',
  borderBottom: '10px solid transparent',
  borderLeft: '10px solid #fff',
});

const ArrowBottom = styled(Element, {
  bottom: '-10px',
  left: 'calc(50% - 10px)',
  borderLeft: '10px solid transparent',
  borderRight: '10px solid transparent',
  borderTop: '10px solid #fff',
});

interface ArrowProps {
  position: Position;
}

export const Arrow = ({ position }: ArrowProps) => {
  return (
    <>
      {position === 'bottom' && <ArrowTop />}
      {position === 'right' && <ArrowLeft />}
      {position === 'left' && <ArrowRight />}
      {position === 'top' && <ArrowBottom />}
    </>
  );
};

export default Arrow;
